import { AuthTokenDTO, LoginRequestDTO } from 'infrastructure/dtos/login';
import { ApiPathConfig } from '../types';
import { UserDTO } from 'infrastructure/dtos/user';

export const Login: ApiPathConfig<LoginRequestDTO, AuthTokenDTO> = {
  method: 'POST',
  path: '/auth/login',
  response: {} as AuthTokenDTO,
  body: {} as LoginRequestDTO,
} as const;

export const Logout: ApiPathConfig<void, void> = {
  method: 'POST',
  path: '/auth/logout',
  response: undefined,
} as const;

export const Authenticate: ApiPathConfig<void, UserDTO> = {
  method: 'GET',
  path: '/user/me',
  response: {} as UserDTO,
} as const;

export const UpdateFCMToken: ApiPathConfig<{ fcm_token: string }, void> = {
  method: 'POST',
  path: '/user/update-fcm',
  response: undefined,
  body: {} as { fcm_token: string },
} as const;

export const DeleteAccount: ApiPathConfig<void, void> = {
  method: 'POST',
  path: '/user/delete',
  response: undefined,
} as const;
